import { useState } from "react";
import { Drawer } from "V2.0/components/DrawerV3";
import { Button } from "V2.0/common/button";
import EvalRunConfigForm from "./EvalRunConfigForm";
import useEvalRunConfigForm from "./useEvalRunConfigForm";
import { message } from "antd";
import { showErrorToast } from "V2.0/utils";

export default EvalRunCreateDialog;

function EvalRunCreateDialog(props) {
  const {
    onClose,
    onCreateEvalRun,
    // Optional. When supplied, a "Save" action appears that persists the test
    // without starting a run, and the primary button becomes "Save & run".
    //
    // AutomatedTesting — the only screen that renders this dialog — always
    // passes it, so in practice both buttons are always shown. The fallback
    // exists for the retired Eval Runs screens (EvalRunsList/, EvalRunCreate/
    // index.tsx), which are still on disk but no longer rendered.
    onSaveTemplate,
    evalRunConfig,
    showPremiumOptions,
    enablePremiumOptions,
    // Offers the Jarvis Labs (India deployed) models as test models; see ModelsSelect.
    showIndiaDeployedModels,
    // Same story: AutomatedTesting always passes a title ("New test" / "Edit
    // test"). This default is the wording the retired screens used.
    title = "Create Eval Run",
  } = props;
  const { formState, updateFormState, errors, validate } =
    useEvalRunConfigForm(evalRunConfig);

  const [loading, setLoading] = useState(false);

  const handleCreate = () => {
    if (!validate()) {
      return;
    }

    function init() {
      setLoading(true);
      message.loading("Creating Eval Run");
    }

    function success() {
      setLoading(false);
      message.destroy();
      message.success("Eval Run Created");
      onClose();
    }

    function error(e) {
      setLoading(false);
      message.destroy();
      showErrorToast(e, "Failed to create Eval Run");
    }

    onCreateEvalRun(formState, { init, success, error });
  };

  const handleSave = () => {
    if (!validate()) {
      return;
    }

    function init() {
      setLoading(true);
      message.loading("Saving test");
    }

    function success() {
      setLoading(false);
      message.destroy();
      message.success("Test saved");
      onClose();
    }

    function error(e) {
      setLoading(false);
      message.destroy();
      showErrorToast(e, "Failed to save test");
    }

    onSaveTemplate(formState, { init, success, error });
  };

  return (
    <Drawer
      open={true}
      onClose={loading ? () => {} : onClose}
      title={title}
    >
      <div className="flex flex-col flex-1 h-full">
        <div className="flex-1 overflow-auto">
          <div className="flex-1 px-6">
            <EvalRunConfigForm
              formState={formState}
              updateFormState={updateFormState}
              errors={errors}
              showPremiumOptions={showPremiumOptions}
              enablePremiumOptions={enablePremiumOptions}
              showIndiaDeployedModels={showIndiaDeployedModels}
            />
          </div>
        </div>

        <div className="shrink-0 flex justify-end gap-x-2 items-center pt-4 px-4">
          <Button
            outline
            disabled={loading}
            onClick={onClose}
          >
            Cancel
          </Button>
          {onSaveTemplate && (
            <Button
              outline
              disabled={loading}
              onClick={handleSave}
            >
              Save
            </Button>
          )}
          <Button
            disabled={loading}
            loading={loading}
            onClick={handleCreate}
          >
            {onSaveTemplate ? "Save & run" : "Create"}
          </Button>
        </div>
      </div>
    </Drawer>
  );
}
